module.exports = __webpack_public_path__ + "img/1-3.69c47e30.png";